export default "__VITE_ASSET__C5AvE5G3__"